<div class="nsw-form">
    <div class="nsw-form__group">
        <fieldset class="nsw-form__date">
            <legend>
                <span class="nsw-form__label">{{label}}</span>
            </legend>
            <div class="nsw-form__date-wrapper">
                <div class="nsw-form__date-input">
                    <label [for]="'form-date-day-' + id" class="nsw-form__label nsw-form__label--small">Day</label>
                    <input type="text" [id]="'form-date-day-' + id" [name]="'form-date-day-' + id"                        
                        class="nsw-form__input" maxlength="2"
                        [formControl]="getFormControl('dateDay')"
                        (keypress)="onDayKeyPress($event, 'dateDay')" (input)="onDateChanged($event)" >
                </div>
                <div class="nsw-form__date-input">
                    <label [for]="'form-date-month-' + id" class="nsw-form__label nsw-form__label--small">Month</label>
                    <input type="text" [id]="'form-date-month-' + id" [name]="'form-date-month-' + id"
                        class="nsw-form__input" maxlength="2" min="1" max="12"
                        [formControl]="getFormControl('dateMonth')"
                        (keypress)="onKeyPress($event)"
                        (input)="onDateChanged($event)">
                </div>
                <div class="nsw-form__date-input nsw-form__date-input--large">
                    <label [for]="'form-date-year-' + id" class="nsw-form__label nsw-form__label--small">Year</label>
                    <input type="text" [id]="'form-date-year-' + id" [name]="'form-date-year-' + id"
                        class="nsw-form__input" maxlength="4" min="1900" max="9999"
                        [formControl]="getFormControl('dateYear')"
                        (keypress)="onKeyPress($event)"
                        (input)="onDateChanged($event)">
                </div>
            </div>
        </fieldset>
    </div>
</div>